import React, { useEffect } from 'react';
import { Outlet, useParams, useNavigate, useLocation } from 'react-router-dom';

const OperationsLayout = () => {
  const { groupKey } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const accounts = location.state?.accountGroup;

  return <Outlet context={{ groupKey, accounts }} />;
};

export default OperationsLayout;
